/**
 * The formatters-custom file is a place to define custom formatters or to
 * override any of the baked-in formatters like phone number formatting.
 *
 * e.g. You may write something like below
 * export function address(profile) {
 *   return `111 Yext Street`;
 * }
 */
export function setNewDomain(str) {
  if (true) {
  	return str.replace('prd.jp.nikon.com', 'www.jp.nikon.com')
  }
  return str
};